import { theme } from 'aimo-ui';
import InfoBox from 'components/common/InfoBox';
import React from 'react';
import { ColumnWithMargins } from 'styles/ContainerStyles';

type InfoTextSectionProps = {
  text: string;
};

export const InfoTextSection = ({ text }: InfoTextSectionProps) => {
  return (
    <ColumnWithMargins mt={10} mr={20} ml={20}>
      <InfoBox
        text={text}
        bgColor={theme.colors.infoYellow}
        padding={15}
        margin={0}
      />
    </ColumnWithMargins>
  );
};

export default InfoTextSection;
